import Util from "./Util";

export default class Playlist {
    constructor () {
        this.id = null;
        this.thumbnailUrl = null;
        this.rating = null;
        this.isPrivate = null;
        this.description = null;
        this.date = null;
        this.duration = null;
        this.videoAssetId = null;
        this.videoAssetName = null;
        this.fromTimestamp = null;
        this.toTimestamp = null;
        this.recordingTime = null;
        this.game = null;
        this.tags = null;
    }

    copy () {
        // Perform a shallow copy
        let duplicate = new Playlist();
        for (let prop in this) {
            duplicate[prop] = this[prop];
        }
        return duplicate;
    }

    static load (playlist) {

        if (playlist === null || playlist.events.length === 0) return null;

        //We assume that we are working with only single-clip playlists
        //Anything else is a soft failure - doesnt correctly handle multi-event playlist
        let mainEvent = playlist.events[0];

        let newPlaylist = new Playlist();

        newPlaylist.id = playlist.id;
        newPlaylist.date = Date.parse(playlist.date);
        newPlaylist.recordingTime = Date.parse(mainEvent.recording_timestamp);

        newPlaylist.gameId = playlist.game ? playlist.game.id : null;
        newPlaylist.game = playlist.game;
        newPlaylist.thumbnailUrl = playlist.hd_thumbnail_url;
        newPlaylist.rating = playlist.rating;
        newPlaylist.isPrivate = playlist.is_private;
        newPlaylist.description = playlist.description;
        newPlaylist.duration = playlist.duration_ms;
        newPlaylist.videoAssetId = mainEvent.video_asset_id;
        newPlaylist.videoAssetName = mainEvent.video_asset_name;
        newPlaylist.fromTimestamp = mainEvent.from_timestamp;
        newPlaylist.toTimestamp = mainEvent.to_timestamp;
        newPlaylist.tags = mainEvent.tags;

        return newPlaylist;
    }

    static create (videoAsset, fromTimestamp, toTimestamp, description, tag, thumbnailUrl) {

        let newPlaylist = new Playlist();

        const rating = Util.getEventRatingConfig(tag).default;
        const isPrivate = Util.playlistShouldBePrivate(tag.action, rating)

        newPlaylist.gameId = videoAsset.game ? videoAsset.game.id : null;
        newPlaylist.game = videoAsset.game;
        newPlaylist.thumbnailUrl = thumbnailUrl;
        newPlaylist.rating = rating;
        newPlaylist.isPrivate = isPrivate || false;
        newPlaylist.description = description;
        newPlaylist.duration = toTimestamp - fromTimestamp;
        newPlaylist.videoAssetId = videoAsset.id;
        newPlaylist.videoAssetName = videoAsset.name;
        newPlaylist.fromTimestamp = fromTimestamp;
        newPlaylist.toTimestamp = toTimestamp;
        newPlaylist.tags = [tag];

        return newPlaylist;
    }

    toJSON () {
        let jsonEvent = {
            description: this.description,
            tags: this.tags,
            from_timestamp: this.fromTimestamp,
            to_timestamp: this.toTimestamp,
            video_asset_id: this.videoAssetId,
        };

        let data = {
            description: this.description,
            rating: this.rating,
            thumbnail_url: this.thumbnailUrl,
            is_private: this.isPrivate,
            events: [ jsonEvent ],
        };

        if (this.id) {
            data.id = this.id;
        }

        return data;
    }

    getVideoUrl (server, preroll, postroll) {
        if (preroll === undefined) {
            preroll = 0;
        }
        if (postroll === undefined) {
            postroll = 0;
        }

        const start = Math.max(0, this.fromTimestamp - preroll);
        const end = this.toTimestamp + postroll;

        return server.url + "/playlist.m3u8/" +
                this.videoAssetId + ":" + start + ":" + end + ";/dynamic.m3u8";
    }

}



// WEBPACK FOOTER //
// ./src/js/include/Playlist.js